import Button from "@/components/Button";
import { resetButton } from "@/lib/styles";
import { SVGCross, SVGPlus } from "@/lib/svg";
import styled, { css } from "styled-components";

type PositionStyleProps = {
  $position: { x: number; y: number };
};

const positionStyles = css<PositionStyleProps>`
  position: absolute;
  top: ${({ $position }) => $position.y}%;
  left: ${({ $position }) => $position.x}%;
`;

const SPOT_WIDTH = "3rem";
const SPOT_HEIGHT = SPOT_WIDTH;

export const Container = styled.button<PositionStyleProps>`
  ${resetButton}
  display: block;
  width: ${SPOT_WIDTH};
  height: ${SPOT_HEIGHT};
  border-radius: 50%;
  background-color: rgba(193, 17, 19, 0.24);

  ${positionStyles}
  transform: translate(-50%, -50%);
  transition: transform 0.3s;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    transform: translate(-50%, -50%) scale(1.2);
  }
`;

export const Anchor = styled(Button)`
  position: absolute;
  left: 100%;
  color: ${({ theme }) => theme.colors.red};
  text-decoration: none;
`;

const iconStyles = css`
  position: absolute;
  width: 1rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
  padding: 0.6rem;
  border-radius: 50%;
`;

export const OpenIcon = styled(SVGPlus)`
  ${iconStyles}
  color: ${({ theme }) => theme.colors.red};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const CloseIcon = styled(SVGCross)`
  ${iconStyles}
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.red};
`;

export const LinkWrapper = styled.div<PositionStyleProps>`
  ${positionStyles};
  transform: translateY(-50%);
  transition: transform 0.3s;
  margin-left: calc(${SPOT_HEIGHT} * 0.5 + 0.5rem);

  &.animation-enter {
    opacity: 0;
  }
  &.animation-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }
  &.animation-exit {
    opacity: 1;
  }
  &.animation-exit-active {
    opacity: 0;
    transition: opacity 200ms;
  }
`;
